import { render } from "./Listado.vue?vue&type=template&id=5f008484&scoped=true"
import script from "./Listado.vue?vue&type=script&lang=js"
export * from "./Listado.vue?vue&type=script&lang=js"

import "./Listado.vue?vue&type=style&index=0&id=5f008484&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f008484"]])

export default __exports__